import { useState, useEffect } from 'react';

/**
 * Hook to load and validate campaign data from JSON
 * @returns {Object} { campaign, isLoading, error }
 */
export const useCampaignLoader = () => {
  const [campaign, setCampaign] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadCampaign = async () => {
      try {
        setIsLoading(true);
        const response = await fetch('/campaigns.json');

        if (!response.ok) {
          throw new Error('Failed to load campaign data');
        }

        const data = await response.json();
        const activeCampaign = data.activeCampaign;

        // Validate campaign
        if (!activeCampaign || !activeCampaign.active) {
          setCampaign(null);
          setIsLoading(false);
          return;
        }

        // Validate dates
        const now = new Date();
        const startDate = new Date(activeCampaign.startDate);
        const endDate = new Date(activeCampaign.endDate);

        // Check if campaign is within valid date range
        if (now >= startDate && now <= endDate) {
          setCampaign(activeCampaign);
        } else {
          setCampaign(null);
        }
      } catch (err) {
        console.error('Error loading campaign:', err);
        setError(err.message);
        setCampaign(null);
      } finally {
        setIsLoading(false);
      }
    };

    loadCampaign();
  }, []);

  return { campaign, isLoading, error };
};
